import { COMPETITORS_ORDER } from 'app/config/competitors.config';
import { isOnEventList } from 'app/config/competitors.config.helper';
import { asModel } from 'app/utils/array';
import { getCompetitorStatus, isCompetitorDisplayed } from 'app/utils/competitors';
import type { FilteredOdds } from 'app/components/MatchPreview/types';
import type { CompetitorOddsWithStatus } from 'app/pages/EventsPage/types';

const getFilteredOdds = (
  competitors: CompetitorOddsWithStatus[],
  template: 'winner-2-way' | 'winner-3-way',
  type: 'match' | 'game',
  userPreferences: CompetitorSlug[] | undefined
): TypeWithRequired<FilteredOdds, 'market'>[] =>
  competitors
    .filter(
      competitor =>
        isOnEventList(competitor) && isCompetitorDisplayed(userPreferences, competitor.slug)
    )
    .map(item => {
      const rightMarket = item.markets.find(
        market => market.event_type === type && market.template === template
      );

      return {
        slug: item.slug,
        market: rightMarket,
        competitorStatus: getCompetitorStatus(item)
      };
    })
    .filter((item): item is TypeWithRequired<FilteredOdds, 'market'> => !!item.market)
    .sort(asModel(COMPETITORS_ORDER, item => item.slug));

const getArbitrage = (odds: FilteredOdds): boolean =>
  !!odds.market?.selections.some(selection => selection.arbitrage_with_pandascore) &&
  odds.competitorStatus === 'up';

export { getFilteredOdds, getArbitrage };
